import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 图片查看
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

// 图片懒加载
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  error: require('@/assets/img/IMGerror.png'),
  loading: require('@/assets/img/loading.gif')
})
Vue.use(Viewer)

import './assets/style/base.css'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
